import type { Todo } from "../../domain/entities.ts";
import { escapeHtml } from "../../ui/text.ts";

export async function chooseChildTask(parent: Todo, candidates: Todo[], collectionName: (id: string | null) => string): Promise<Todo | null> {
  if (!candidates.length) return null;
  const dialog = document.createElement("dialog");
  dialog.className = "name-dialog task-hierarchy-dialog";
  dialog.setAttribute("aria-label", "Attach an existing task");
  dialog.innerHTML = `<form method="dialog"><h2>Attach an existing task</h2><p>The task will become a child of ${escapeHtml(parent.title || "this task")}.</p><label class="field-label">Task<select name="childId" required>${candidates.map(task => `<option value="${escapeHtml(task.id)}">${escapeHtml(task.title || "Untitled task")} · ${escapeHtml(collectionName(task.categoryId))}</option>`).join("")}</select></label><p class="field-note">You can detach or move it later. It keeps its content and completion state.</p><div class="dialog-actions"><button class="button button--soft" value="cancel">Cancel</button><button class="button button--primary" value="attach">Attach task</button></div></form>`;
  document.body.append(dialog);
  return new Promise(resolve => {
    dialog.addEventListener("close", () => {
      const selected = candidates.find(task => task.id === dialog.querySelector<HTMLSelectElement>("[name=childId]")?.value);
      const result = dialog.returnValue === "attach" ? selected || null : null;
      dialog.remove();
      resolve(result);
    }, { once: true });
    dialog.addEventListener("click", event => { if (event.target === dialog) dialog.close("cancel"); });
    dialog.showModal();
    dialog.querySelector<HTMLSelectElement>("[name=childId]")?.focus();
  });
}
